import { useQuery } from '@hooks/reactQuery';

import { getConfigurationTemplateNetworkElements } from '@api/configurationTemplates';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithIdName } from '@utils/formatter';

import { IConfigurationTemplateNetworkElementsDTO } from '@interfaces/cmModule/dto/configurationTemplatesDTO';
import { TIdName } from '@interfaces/common/common';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONFIGURATION_TEMPLATES_NETWORK_ELEMENTS } from '@constants/queryKeys';

interface IUseQueryConfigurationTemplatesNetworkElementsReturned {
	networkElements: TSelectOption<string>[];
	isLoadingNetworkElements: boolean;
}

const useQueryConfigurationTemplatesNetworkElements = (
	params: Partial<IConfigurationTemplateNetworkElementsDTO>,
): IUseQueryConfigurationTemplatesNetworkElementsReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<TIdName[], TSelectOption<string>[]>({
		queryKey: [CONFIGURATION_TEMPLATES_NETWORK_ELEMENTS, params],
		queryFn: extractQueryParams(getConfigurationTemplateNetworkElements),
		select: optionsFormattedWithIdName,
		enabled: [!!params.configType],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		networkElements: data || [],
		isLoadingNetworkElements: isInitialLoading,
	};
};

export default useQueryConfigurationTemplatesNetworkElements;
